import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as Common from '_common';
import * as Components from '_components';
export function TimeSmallRender(component, index) {
    return _jsx(TimeSmallWidget, {});
}
const TimeSmallWidget = () => (_jsx(Components.Refresh, { afterMs: 500, children: () => (_jsxs(_Fragment, { children: [_jsx(DateTime, {}), _jsx(DayInfo, {})] })) }));
const TimeButtonWidget = () => (_jsx(Components.Button, { children: _jsx(Components.Refresh, { afterMs: 500, children: () => _jsx("h4", { children: new Date().toLocaleTimeString() }) }) }));
export function TimeFullRender(component, index) {
    return _jsx(TimeFullWidget, {});
}
const TimeFullWidget = () => (_jsx(Components.Refresh, { afterMs: 500, children: () => (_jsxs(_Fragment, { children: [_jsx(DateTime, {}), _jsx(DayInfo, {}), _jsx(WorkingDay, {})] })) }));
export function TimeFrameRender(component, index) {
    return _jsx(TimeFrameWidget, {});
}
const TimeFrameWidget = () => (_jsx(Components.Refresh, { afterMs: 500, children: () => _jsx(DateTime, {}) }));
function DateTime() {
    const date = new Date();
    return (_jsxs(_Fragment, { children: [_jsx("h4", { children: getDayString(date) }), _jsx("h1", { children: date.toLocaleTimeString() })] }));
}
function DayInfo() {
    const context = Common.useSpaContext();
    const dayInfo = context?.state?.day;
    if (!dayInfo?.holiday || dayInfo?.holiday === '-') {
        return (_jsx(Components.Property, { title: _jsx(Components.MLT, { cs: "St\u00E1tek m\u00E1", en: "Name day" }), children: dayInfo?.nameDay }, "1"));
    }
    else {
        return (_jsx(Components.Property, { title: _jsx(Components.MLT, { cs: "Dnes je", en: "Holiday" }), children: dayInfo?.holiday }, "2"));
    }
}
function WorkingDay() {
    const context = Common.useSpaContext();
    const dayInfo = context?.state?.day;
    return (_jsx(Components.Property, { title: _jsx(Components.MLT, { cs: "Pracovn\u00ED den", en: "Is working day" }), children: _jsx(Components.BooleanText, { value: dayInfo?.isWorkingDay }) }, "3"));
}
function getDayString(date) {
    const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dayOfWeek = dayNames[date.getDay()];
    return dayOfWeek + ' ' + date.toLocaleDateString();
}
